<template>
  <div class="project-list">
    <slot name="inner" />
    <Emtry v-if="!list.length" />
  </div>
</template>

<script>
import Emtry from '@/components/base/Emtry.vue'
export default {
  components: {
    Emtry
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }

}
</script>

<style lang="scss" scoped>
.project-list{
  display: flex;
  flex-wrap: wrap;
}
</style>
